import React from 'react';
import type { HTMLAttributes, ElementRef, Ref } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import { CrossOutline } from '@backyard-ui/icons';

export interface TagCloseButtonProps
  extends Omit<HTMLAttributes<HTMLButtonElement>, 'size'> {
  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLButtonElement>;
}

const TagCloseButtonEl = styled('button', {
  position: 'relative',
  left: '$1',

  display: 'flex',
  flexShrink: 0,

  padding: '$1',

  color: 'inherit',

  appearance: 'none',
  cursor: 'pointer',
  userSelect: 'none',

  border: 0,
  borderRadius: '$full',

  outline: 'none',
  backgroundColor: 'transparent',

  transitionProperty:
    'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
  transitionDuration: '200ms',

  '&:active': {
    backgroundColor: '$n300',
  },

  '&:focus': {
    focus: '$n500',
  },

  '&:hover': {
    backgroundColor: '$n300',
  },

  svg: {
    width: '$2',
    height: '$2',
  },
});

const TagCloseButton = React.forwardRef<
  ElementRef<'button'>,
  TagCloseButtonProps
>((props, ref) => {
  return (
    <TagCloseButtonEl type="button" aria-label="close" ref={ref} {...props}>
      <CrossOutline />
    </TagCloseButtonEl>
  );
});

TagCloseButton.displayName = 'TagCloseButton';

export default TagCloseButton;
